module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_ffffff_256x240-08607039f9a769545fb52f6db231538c.png";